import { getPhoneCodeByTimezone } from 'timezone-phone-codes';
import ct from 'countries-and-timezones';

const getTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

export const getActiveDialCode = () => {
  const code = getPhoneCodeByTimezone(getTimezone());
  return code === '+66' ? '+84' : (code || '+84');
};

export const getActiveCountryCode = () => {
  const country = ct.getCountryForTimezone(getTimezone()) || {};
  const countryId = country.id || '';
  return countryId === 'TH' ? 'VN' : (countryId || 'VN');
};
